import React from 'react';

import { Col, Row } from 'antd';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import useStore from '../../../../hooks/useStore';
import {
  CamptonBlack22,
  ContentSmallCamptonBookWeight625,
  GreenLinkText,
  H8CamptonSemiBold20,
  SmallGrey12
} from '../../../../layout/globalFonts';
import ContentStore from '../../../../stores/ContentStore';
import ModalStore from '../../../../stores/ModalStore';
import { ProductInfo } from '../../../../swagger/api';
import licensePlateFormatting from '../../../../utils/licensePlateFormatting';
import PublicCustomerWantsToEditAnprLicensePlate from '../modals/PublicCustomerWantsToEditAnprLicensePlate';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface VehicleInformationTileProps {
  productInfo: ProductInfo;
}

const VehicleInformationTile: React.FC<VehicleInformationTileProps> = ({ productInfo }) => {
  const contentStore = useStore(ContentStore) as ContentStore;
  const modalStore = useStore(ModalStore) as ModalStore;

  const openEditLicensePlateModal = () => {
    modalStore.openModal(<PublicCustomerWantsToEditAnprLicensePlate productInfo={productInfo} />);
  };

  return (
    <Container>
      <Row style={{ marginBottom: '10px' }}>
        <H8CamptonSemiBold20>
          {contentStore.cmsStore.getContent('Vehicle')?.content}
        </H8CamptonSemiBold20>
      </Row>
      <Row>
        <SmallGrey12>{contentStore.cmsStore.getContent('licensePlate')?.content}</SmallGrey12>
      </Row>
      <Row>
        <CamptonBlack22>{licensePlateFormatting(productInfo.licensePlate)}</CamptonBlack22>
      </Row>
      <Row justify="space-between" style={{ marginTop: '20px' }} gutter={[12, 12]}>
        <Col>
          <Row>
            <SmallGrey12>{contentStore.cmsStore.getContent('Model')?.content}</SmallGrey12>
          </Row>
          <Row>
            <ContentSmallCamptonBookWeight625>
              {productInfo.brand ? `${productInfo.brand} ${productInfo.model}` : '-'}
            </ContentSmallCamptonBookWeight625>
          </Row>
        </Col>
        <Col>
          <Row>
            <SmallGrey12>{contentStore.cmsStore.getContent('Color')?.content}</SmallGrey12>
          </Row>
          <Row>
            <ContentSmallCamptonBookWeight625>
              {productInfo.color ? productInfo.color : '-'}
            </ContentSmallCamptonBookWeight625>
          </Row>
        </Col>
        <Col>
          <Row>
            <SmallGrey12>{contentStore.cmsStore.getContent('Country')?.content}</SmallGrey12>
          </Row>
          <Row>
            <ContentSmallCamptonBookWeight625>
              {productInfo.countryIsoCode}
            </ContentSmallCamptonBookWeight625>
          </Row>
        </Col>
      </Row>
      <Row style={{ marginTop: 'auto' }}>
        <GreenLinkText style={{ cursor: 'pointer' }} onClick={openEditLicensePlateModal}>
          {contentStore.cmsStore.getContent('EditLicensePlate')?.content}
        </GreenLinkText>
      </Row>
    </Container>
  );
};

export default observer(VehicleInformationTile);
